import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { HeaderComponent } from './screens/header/header.component';
import { FooterComponent } from './screens/footer/footer.component';
import { HomeComponent } from './screens/home/home.component';
import { AlumniComponent } from './screens/home/alumni/alumni.component';
import { BulletinComponent } from './screens/home/bulletin/bulletin.component';
import { CounterComponent } from './screens/home/counter/counter.component';
import { HomeGalleryComponent } from './screens/home/home-gallery/home-gallery.component';
import { MessagesComponent } from './screens/home/messages/messages.component';
import { ProgramsComponent } from './screens/home/programs/programs.component';
import { ShowcaseComponent } from './screens/home/showcase/showcase.component';
import { VisionComponent } from './screens/home/vision/vision.component';
import { WhyComponent } from './screens/home/why/why.component';
import { SharedModule } from './modules/shared/shared.module';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RecruiterComponent } from './screens/home/recruiter/recruiter.component';
import { LuminariesComponent } from './screens/home/luminaries/luminaries.component';
import { HomeAboutComponent } from './screens/home/home-about/home-about.component';
import { EventsComponent } from './screens/home/events/events.component';

import { AlumniRegistrationComponent } from './screens/forms/alumni-registration/alumni-registration.component';

import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { environment } from 'src/environments/environment';
import { GalleryComponent } from './screens/gallery/gallery.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    BulletinComponent,
    CounterComponent,
    HomeGalleryComponent,
    MessagesComponent,
    ProgramsComponent,
    ShowcaseComponent,
    VisionComponent,
    WhyComponent,
    AlumniComponent,
    RecruiterComponent,
    LuminariesComponent,
    HomeAboutComponent,
    EventsComponent,

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    SharedModule,
    CarouselModule,
    FormsModule,
    ReactiveFormsModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireDatabaseModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
